"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3 = void 0;
const characters_1 = require("./characters");
const stories_1 = require("./stories");
const media_1 = require("./media");
exports.S3 = {
    stories: stories_1.stories,
    characters: characters_1.characters,
    media: media_1.media,
};
//# sourceMappingURL=index.js.map